export default "__VITE_ASSET__CRsoNqdQ__"